// extracted by mini-css-extract-plugin
export default {"nav":"Stats_nav__XjbgJ"};